// extracted by mini-css-extract-plugin
export var hidden = "_6r-1";
export var visible = "_6r-0";